

<template>
    <div id="Innerdiv">
        <div v-if="hasResult">
            <div v-show="ShowResult">
                <div class="col-12">
                    <div v-for="item in ElasticData">
                        <div>
                            <div v-for="item in ElasticData" style="border-bottom: 1px solid #eee !important; margin-bottom: 15px;">
                                <elastic-search-item :ElasticData="item" :addedToCart="addedToCart" :ShowRelated="ShowRelated" :ShowJournalPrices="true" :RequestSource="'details'" :ShowShoppingCartStatus="ShowShoppingCart">
                                    <input slot="wishlistButton" type="button" class="second-btn w-100" background-color: #414751; color: white;"
                                           :value="translationKeywords.addToWishList"
                                           @click="OpenwishList(item._source.productReference)" />
                                    <input slot="wishlistButton" type="button" class="second-btn w-100"
                                           style="background-color: #414751; color: white;"
                                           :value="translationKeywords.addToWishList"
                                           @click="OpenwishList(item._source.productReference)" />
                                </elastic-search-item>
                            </div>
                            <b-card-text class=" card-details-table">
                                <div>
                                    <table class="table table-hover" v-show="ShowLibraryResult" v-if="LibraryResult && LibraryResult.length>0">
                                        <thead>
                                            <tr v-for="ColumnNames in colNames" style="background-color: #eee;">
                                                <th width="10%">{{ColumnNames.quantity}}</th>
                                                <th>{{ColumnNames.orderId}}</th>
                                                <th>{{ColumnNames.orderdate}}</th>
                                                <th>{{ColumnNames.signature}}</th>
                                                <th>{{ColumnNames.departmentName}}</th>
                                                <th>{{ColumnNames.location}}</th>
                                                <th>{{ColumnNames.orderStatus}}</th>
                                                <th hidden>{{ColumnNames.userName}}</th>
                                                <th>{{ColumnNames.costCenter}}</th>
                                                <th hidden>{{ColumnNames.deliveryEntry}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in LibraryResult">
                                                <td>{{item.quantity}}</td>
                                                <td>{{item.orderid}}</td>
                                                <td>{{ConvertDate(item.orderdate)}}</td>
                                                <td>{{item.SIGNATURE}}</td>
                                                <td>{{item.departmentname}}</td>
                                                <td>{{item.location}}</td>
                                                <td>{{item.orderstatus}}</td>
                                                <td hidden>{{item.username}}</td>
                                                <td>{{item.costcentername}}</td>
                                                <td hidden></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-if="showPagination">
                                    <pagination :total-pages="ResultCount"
                                                :total="5"
                                                :per-page="5"
                                                :current-page="currentPage"
                                                @pagechanged="onPageChange" />
                                </div>
                                <b-card no-body class="d-block card-area-body" style=" border-bottom: 1px solid #eee !important;" id="productdescription" v-if="item._source.texts && item._source.texts.length>0 && item._source.texts[0]">
                                    <b-card-header header-tag="header" class="p-1 " style="background-color:#fff;" role="tab">
                                        <b-button block href="#" class="tab-header" v-on:click="isActive = !isActive" style=" border-radius: 0 !important;">
                                            {{translationKeywords.productdescription}}
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-1" visible v-if="isActive" role="tabpanel">
                                        <b-card-body v-if="item._source.texts">
                                            <b-card-text style="max-width: 100%">
                                                <div v-for="text in item._source.texts">
                                                    <p v-if="text.textTypeCode=='Main Description' ||text.textTypeCode=='Hauptbeschreibung'" v-html="formatetxt(text.text)"></p>
                                                </div>
                                                <div v-for="text in item._source.texts">
                                                    <p v-if="text.textTypeCode=='Long Description' ||text.textTypeCode=='Langbeschreibung'" v-html="formatetxt(text.text)"></p>
                                                </div>
                                                <div v-for="text in item._source.texts">
                                                    <p v-if="text.textTypeCode=='Short description/annotation' ||text.textTypeCode=='Kurzbeschreibung'" v-html="formatetxt(text.text)"></p>
                                                </div>
                                                <div v-for="text in item._source.texts">
                                                    <p v-if="text.textTypeCode=='DescriptionForReader' ||text.textTypeCode=='Beschreibung für Leser'" v-html="formatetxt(text.text)"></p>
                                                </div>
                                                <div v-for="text in item._source.texts">
                                                    <p v-if="text.textTypeCode=='QuoteFromReviewOfPreviousEdition' ||text.textTypeCode=='QuoteFromReviewOfPreviousEdition'" v-html="formatetxt(text.text)"></p>
                                                </div>
                                                <div v-for="text in item._source.texts">
                                                    <p v-if="text.textTypeCode=='Table Of Contents' ||text.textTypeCode=='Inhaltsverzeichnis'" v-html="formatetxt(text.text)"></p>
                                                </div>
                                                <div v-for="text in item._source.texts">
                                                    <p v-if="text.textTypeCode=='PreviousReviewQuote' ||text.textTypeCode=='PreviousReviewQuote'" v-html="formatetxt(text.text)"></p>
                                                </div>
                                                <div v-for="text in item._source.texts">
                                                    <p v-if="text.textTypeCode=='AuthorComments' ||text.textTypeCode=='AuthorComments'" v-html="formatetxt(text.text)"></p>
                                                </div>
                                                <div v-for="text in item._source.texts">
                                                    <p v-if="(text.text.length>0 && text.textTypeCode==='Biographical note' ||text.textTypeCode==='Autorenporträt')">Über die Verfasser:</p>
                                                    <p v-if="text.textTypeCode=='Biographical note' || text.textTypeCode=='Autorenporträt'" v-html="formatetxt(text.text)"></p>
                                                </div>
                                                <div v-for="pdf in item._source.pdFs">
                                                    <a :href="pdf.textLink" class="PdfLinks">
                                                        {{pdf.textTypeCode}}
                                                    </a>
                                                </div>
                                                <div v-for="contributor in item._source.contributors">                                                      
                                                            <div  v-for="idValue in contributor.personNameIdentifiers">
                                                                <div class="contributor-section " v-if="idValue.personNameidType === '25'">
                                                                    <p class="biographicalTableLable mb-0"  :key="index">{{contributor.keyNames}}:</p>
                                                                    <a :key="index" :href="generateItemLink(idValue.idvalue, 'personnameidentifiers', contributor.keyNames)" class="person-identifier-link biographicalTableValue">{{translationKeywords.personIdentifier}}</a>
                                                                </div>
                                                            </div>
                                                </div>
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                                <b-card no-body class="d-block card-area-body" style="border-bottom: 1px solid #eee !important;" id="biographicalNote">
                                    <b-card-header header-tag="header" class="p-1" style="background-color:#fff;" role="tab">
                                        <b-button block href="#" class="tab-header" v-on:click="isHidden = !isHidden" style="border-radius: 0 !important;">
                                            {{translationKeywords.biographicalNote}}
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-2" v-if="!isHidden" visible role="tabpanel">
                                        <b-card-body>
                                            <b-card-text>
                                                <table>
                                                    <tr v-if="AuthorsList && AuthorsList.length > 0">
                                                        <td class="biographicalTableLable">
                                                            <span> {{translationKeywords.author}}</span>

                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            <span v-show></span>{{AuthorsList}}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="EditorsList && !(item._source.mediaType==14 || item._source.mediaType=='Journal')">
                                                        <td class="biographicalTableLable">
                                                            <span>  {{translationKeywords.editor}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            {{EditorsList}}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.mediaType==14 || item._source.mediaType=='Journal'">
                                                        <td class="biographicalTableLable">
                                                            <span> {{translationKeywords.editor}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            {{item._source.contributorStatement}}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.isbN13Hyphens">
                                                        <td class="biographicalTableLable">
                                                            <span> ISBN13</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            {{item._source.isbN13Hyphens}}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.isbN10Hyphens">
                                                        <td class="biographicalTableLable">
                                                            <span> ISBN10</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            {{item._source.isbN10Hyphens}}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.audienceDescription">
                                                        <td class="biographicalTableLable">
                                                            <span> {{translationKeywords.furtherInfo_Audience}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            {{item._source.audienceDescription}}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.mediaType==14 || item._source.mediaType=='Journal'">
                                                        <td class="biographicalTableLable">
                                                            <span> ISSN</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            {{item._source.issn}}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="(item._source.mediaType==14 || item._source.mediaType=='Journal') && item._source.termsOfNotice != nulls">
                                                        <td class="biographicalTableLable">
                                                            <span>  {{translationKeywords.termOfNotice}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            {{item._source.termsOfNotice}}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="(item._source.mediaType==14 || item._source.mediaType=='Journal') && item._source.audienceDescription">
                                                        <td class="biographicalTableLable">
                                                            <span> {{translationKeywords.audience}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            {{item._source.audienceDescription}}
                                                        </td>
                                                    </tr>
                                                    <!--&& item._source.texts[0].textTypeCode=='Description for press or other media'-->
                                                    <tr v-for="txt in item._source.texts" v-if="(item._source.mediaType==14 || item._source.mediaType=='Journal') && txt.textTypeCode=='Description for press or other media'">
                                                        <td class="biographicalTableLable">
                                                            <span> {{translationKeywords.termsAndConditions}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">{{txt.text}}​​​​​</td>
                                                    </tr>
                                                    <!--<tr v-if="(item._source.mediaType==14 || item._source.mediaType=='Journal')">
                                                <td class="biographicalTableLable">
                                                    {{translationKeywords.termsAndConditions}}
                                                </td>
                                                <td v-for="text in item._source.texts" class="biographicalTableValue">
                                                    <span v-if="text.typeCode=='Main description'">
                                                        {{text.text}}
                                                    </span>
                                                </td>
                                            </tr>-->
                                                    <tr v-if="item._source.publicationLanguages && item._source.publicationLanguages.length>0">
                                                        <td class="biographicalTableLable">
                                                            <span> {{translationKeywords.language}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            <span class="custom-split" v-for="lang in item._source.publicationLanguages">{{lang}}</span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.series && item._source.series.length > 0">
                                                        <td class="biographicalTableLable">
                                                            <span> {{translationKeywords.Series}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            <p v-for="series in item._source.series" class="sparate-content">
                                                                <span v-if="series.title && series.title.length > 0">{{series.title[0]}}</span>
                                                                <span v-if="series.subtitle && series.subtitle.length > 0">{{series.subtitle[0]}}</span>
                                                                <span v-if="series.numberWithinSeries">{{series.numberWithinSeries}}</span>
                                                                <span v-if="series.seriesIdentifier && series.seriesIdentifier.length > 0">{{series.seriesIdentifier[0]}}</span>
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.cityOfPublication">
                                                        <td class="biographicalTableLable">
                                                            <span> {{translationKeywords.publicationCountry}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            {{item._source.cityOfPublication}}<span v-if="item._source.countryOfPublication">, {{item._source.countryOfPublication}}</span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.measures && item._source.measures.length>0">
                                                        <td class="biographicalTableLable">
                                                            <span>  {{translationKeywords.measures}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            {{formatMeasurement(Displaymeasurement(item._source.measures))}}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.price && item._source.price.bundle">
                                                        <td class="biographicalTableLable">
                                                            <span> {{translationKeywords.bundle}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            <span v-for="(Bundleitem,index) in BundlePriceTxt">{{Bundleitem}}</span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.orderTime && item._source.availability_Text == 'Available'">
                                                        <td class="biographicalTableLable">
                                                            <span> {{translationKeywords.orderTime}}</span>
                                                        </td>
                                                        <td class="biographicalTableValue">
                                                            {{item._source.orderTime}} {{translationKeywords.orderTimeDays}}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                                <b-card no-body class="d-block card-area-body" style="border-bottom: 1px solid #eee !important;" id="keyWords"
                                        v-if="item._source.newbooksClassification || item._source.wgs || item._source.thema || item._source.keywords ">
                                    <b-card-header header-tag="header" class="p-1" style="background-color:#fff;" role="tab">
                                        <b-button block href="#" class="tab-header" v-on:click="isHide = !isHide" style="border-radius: 0 !important;">
                                            {{translationKeywords.keyWords}}
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-3" v-if="!isHide" visible role="tabpanel">
                                        <b-card-body>
                                            <b-card-text>
                                                <table>
                                                    <tr v-if="item._source.newbooksClassification && item._source.newbooksClassification.length>0">
                                                        <td class="keywordTableLable">
                                                            {{translationKeywords.keywords_NewbooksClassification}}:
                                                        </td>
                                                        <td class="keywordTableValue">
                                                            <span v-for="(nbClassification,index) in item._source.newbooksClassification"><a :href="generateItemLink(nbClassification.code, 'newbooksClassification', nbClassification.display_Ger)">{{nbClassification.display_Ger}}</a><span v-if="index!=(item._source.newbooksClassification.length-1)">;&nbsp;</span></span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.wgs && item._source.wgs.length>0">
                                                        <td class="keywordTableLable">
                                                            {{translationKeywords.keywords_Warengruppe}}:
                                                        </td>
                                                        <td class="keywordTableValue">
                                                            <span v-for="item in item._source.wgs"><a :href="generateItemLink(item.code, 'wgs', item.display_Ger)">{{item.display_Ger}}</a></span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.thema && item._source.thema.length>0">
                                                        <td class="keywordTableLable">
                                                            {{translationKeywords.keywords_Thema}}:
                                                        </td>
                                                        <td class="keywordTableValue">
                                                            <span v-for="(thema, index) in item._source.thema">
                                                                <span>
                                                                    <a :href="generateItemLink(thema.code, 'thema', thema.display_Ger)">{{thema.display_Ger}}</a>
                                                                    <span v-if="index!=(item._source.thema.length-1)">;&nbsp;</span>
                                                                </span>
                                                            </span>
                                                            <div v-if="(item._source.thema && item._source.thema.length>0)||(item._source.ort && item._source.ort.length>0)||(item._source.sprache && item._source.sprache.length>0)||(item._source.zeitepoche && item._source.zeitepoche.length>0)||(item._source.bildung && item._source.bildung.length>0)||(item._source.interessen && item._source.interessen.length>0)||(item._source.stil && item._source.stil.length>0)">
                                                                <br>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.ort && item._source.ort.length>0">
                                                        <td class="keywordTableLable-tr-key">
                                                            {{translationKeywords.keywords_Ort}}:
                                                        </td>
                                                        <td class="keywordTableLable-tr">
                                                            <span v-for="(ort, index) in item._source.ort">
                                                                <span>{{ort.display_Ger}}<span v-if="index!=(item._source.ort.length-1)">;&nbsp;</span></span>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.sprache && item._source.sprache.length>0">
                                                        <td class="keywordTableLable-tr-key">
                                                            {{translationKeywords.keywords_Sprache}}:
                                                        </td>
                                                        <td class="keywordTableLable-tr">
                                                            <span v-for="(Sprache, index) in item._source.sprache">
                                                                <span>{{Sprache.display_Ger}}<span v-if="index!=(item._source.sprache.length-1)">;&nbsp;</span></span>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.zeitepoche && item._source.zeitepoche.length>0">
                                                        <td class="keywordTableLable-tr-key">
                                                            {{translationKeywords.keywords_Zeitepoche}}:
                                                        </td>
                                                        <td class="keywordTableLable-tr">
                                                            <span v-for="(zeitepoche, index) in item._source.zeitepoche">
                                                                <span>{{zeitepoche.display_Ger}}:<span v-if="index!=(item._source.zeitepoche.length-1)">;&nbsp;</span></span>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.bildung && item._source.bildung.length>0">
                                                        <td class="keywordTableLable-tr-key">
                                                            {{translationKeywords.keywords_Bildung}}:
                                                        </td>
                                                        <td class="keywordTableLable-tr">
                                                            <span v-for="(Bildung, index) in item._source.bildung">
                                                                <span>{{Bildung.display_Ger}}<span v-if="index!=(item._source.bildung.length-1)">;&nbsp;</span></span>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.interessen && item._source.interessen.length>0">
                                                        <td class="keywordTableLable-tr-key">
                                                            {{translationKeywords.keywords_Interessen}}:
                                                        </td>
                                                        <td class="keywordTableLable-tr">
                                                            <span v-for="(Interessen, index) in item._source.interessen">
                                                                <span>{{Interessen.display_Ger}}<span v-if="index!=(item._source.interessen.length-1)">;&nbsp;</span></span>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.stil && item._source.stil.length>0">
                                                        <td class="keywordTableLable-tr-key">
                                                            {{translationKeywords.keywords_Stil}}:
                                                        </td>
                                                        <td class="keywordTableLable-tr">
                                                            <span v-for="(Stil, index) in item._source.stil">
                                                                <span>{{Stil.display_Ger}}<span v-if="index!=(item._source.stil.length-1)">;&nbsp;</span></span>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.keywords && item._source.keywords.length>0">
                                                        <td class="keywordTableLable">
                                                            {{translationKeywords.keywords_Schlagworte}}:
                                                        </td>
                                                        <td class="keywordTableValue">
                                                            <span v-for="(keyword, index) in item._source.keywords">
                                                                <span v-if="index<20">
                                                                    <span class="custom-split">{{keyword}}<span v-if="index < item._source.keywords.length-1">;&nbsp;</span></span>
                                                                </span>
                                                                <span v-else v-show="showMoreKeyWords"><span v-if="index==20">, </span>{{keyword}}</span>
                                                            </span>
                                                            <a v-if="item._source.keywords.length>20" class="expander" @click="ShowAllKeyWords()" v-show="!showMoreKeyWords">...mehr anzeigen</a>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item._source.motifs && item._source.motifs.length>0">
                                                        <td class="keywordTableLable">
                                                            {{translationKeywords.keywords_Lesemotive}}:
                                                        </td>
                                                        <td class="keywordTableValue">
                                                            <span v-for="(motif, index) in item._source.motifs">
                                                                <span v-if="index<20">
                                                                    <span class="custom-split">{{motif}}<span v-if="index < item._source.motifs.length-1">;&nbsp;</span></span>
                                                                </span>
                                                                <span v-else v-show="showMoreMotifs"><span v-if="index==20">, </span>{{motif}}</span>
                                                            </span>
                                                            <a v-if="item._source.motifs.length>20" class="expander" @click="ShowAllMotifs()" v-show="!showMoreMotifs">...mehr anzeigen</a>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </b-card-text>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </b-card-text>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center" v-show="!ShowResult && !showNotAuthMessage">
                <b-spinner variant="" label="Text Centered"></b-spinner>
            </div>

            <div v-show="showNotAuthMessage" class="not-authorized-message">
                <h5 class="mb-0">
                    Sie haben keinen Zugriff auf dieses Modul.
                </h5>
            </div>
        </div>
        <div v-else>
            <h2>{{translationKeywords.noResult}}</h2>

            <search-request :mode="1" :searchKeyword="searchRequestTerm"
                            :advancedSearchText="getString('advancedSearch')" :formOpenerText="getString('searchFormTitle')"
                            :searchText="searchFormText" :formTitle="getString('searchFormTitle')" :formHelp="getString('searchFormHelp')"
                            :okTitle="getString('send')" :cancelTitle="getString('cancel')">


            </search-request>
        </div>
    </div>

</template>
<script>
    import ResourceHelper from "@/common/globalization/ResourceHelper";
    import { generateLink } from "@/common/custom.js";
    import pagination from '@/components/pagination.vue';
    import ElasticSearchItem from "./ElasticSearchItem.vue";
    import wishList from "@/LDE_Modules/ElasticWishListModule/WishListPopup.vue";
    import searchRequest from "@/LDE_Modules/ContactForms/SearchForm/SearchForm.vue";
    import { BAlert } from 'bootstrap-vue';
    Vue.component('b-alert', BAlert);
    export default {
        name: 'detail-elastic-search',
        props: ['productReference', 'ShowShoppingCartStatus'],
        data: function () {
            return {
                isActive: true,
                isHide: true,
                isHidden: true,
                hasNoResult: true,
                hasResult: true,
                ElasticData: [],
                hasCartResult: false,
                addedToCart: false,
                LibraryResult: [],
                ShowLibraryResult: false,
                colNames: [],
                currentPage: 1,
                generateItemLink: generateLink,
                translationKeywords: {
                    productdescription: '',
                    biographicalNote: '',
                    keyWords: '',
                    addShoppingCart: '',
                    addToWishList: '',
                    productform: '',
                    noResult: '',
                    termOfNotice: '',
                    audience: '',
                    termsAndConditions: '',
                    keywords_NewbooksClassification: "",
                    keywords_Wgs: "",
                    keywords_Stil: "",
                    keywords_Interessen: "",
                    keywords_Bildung: "",
                    keywords_Zeitepoche: "",
                    keywords_Sprache: "",
                    keywords_Ort: "",
                    keywords_Thema: "",
                    keywords_Warengruppe: "",
                    keywords_Schlagworte: "",
                    keywords_Lesemotive: "",
                    furtherInfo_Audience: "",
                    Series: "",
                    author: "",
                    editor: "",
                    language: "",
                    publicationCountry: "",
                    bundle: "",
                    measures: "",
                    personIdentifier:""

                },
                showPagination: false,
                showNotAuthMessage: false,
                ResultCount: '',
                ShowResult: false,
                showMoreKeyWords: false,
                showMoreMotifs: false,
                ShowRelated: true,
                ItemEan: "",
                AuthorsList: "",
                EditorsList: "",
                ShowShoppingCart: false,
                searchRequestTerm: "",
                SavedCurrentUrl: '',
                searchFormText: ""
            }
        },
        methods: {
            ConvertDate: function (date) {
                const itemdate = new Date(date);
                return itemdate.getUTCDay() + '/' + itemdate.getMonth() + '/' + itemdate.getFullYear();
            },
            CheckItemInTheCart: function () {
                var self = this;
                self.addedToCart = false;
                var SearchUrl = getSearchUrl();
                var UserGuid = getCookie("UserId");
                var isbn = getUrlParameter("Id");
                axios({
                    method: 'Get',
                    url: SearchUrl + '/api/cart/checkitem/' + UserGuid + '/' + isbn,
                    headers: {
                        "portal-culture": getCookie("Esperantus_Language_languageSwitcher")
                    }
                }).then(function (result) {
                    if (result.status === 200) {
                        self.hasCartResult = true;
                        self.addedToCart = result.data;
                    }
                    else {
                        self.hasCartResult = false;
                        self.addedToCart = false;
                    }
                });
            },
            GetItemDetials: function (ISBN) {
                var refTothis = this;
                refTothis.ElasticData = [];
                this.searchKeyWord = this.searchterm;
                var obj = JSON.parse(DecodeUrl(refTothis.currentPage));
                refTothis.searchRequestTerm = ISBN;
                refTothis.searchFormText = refTothis.getString('searchFormNoResults').replace('{0}', refTothis.searchRequestTerm);
                var Lang = getCookie("Esperantus_Language_languageSwitcher");
                var UserGuid = getCookie("UserId");
                var SearchUrl = getSearchUrl();
                var PortalId = getCookie("PortalId");
                axios({
                    method: 'Get',
                    url: SearchUrl + '/Search/DetailSearch?ProductReference=' + ISBN + '&culture=' + Lang + '&PageNumber=' + refTothis.currentPage + "&PortalId=" + PortalId + "&UserGuid=" + UserGuid,
                    headers: {
                        "portal-culture": getCookie("Esperantus_Language_languageSwitcher")
                    }
                }).then(function (result) {
                    if (result.status === 200) {
                        refTothis.hasResult = true;
                        refTothis.ShowResult = true;
                        refTothis.hasNoResult = false;
                        if (refTothis.currentPage !== '1') {
                            refTothis.ElasticData = result.data.searchResult;
                            refTothis.LibraryResult = result.data.libraryResult;
                            refTothis.colNames = result.data.columnNames;
                            if (refTothis.LibraryResult && refTothis.LibraryResult.length > 0) {
                                refTothis.ResultCount = Math.ceil(Number(result.data.libraryResult[0].counttotal) / 5);
                            }
                        }
                        else {

                            refTothis.LibraryResult = result.data.libraryResult;
                        }
                        if (refTothis.LibraryResult && refTothis.LibraryResult.length >= 0) {
                            refTothis.ShowLibraryResult = true;

                            if (refTothis.ResultCount > 1) {
                                refTothis.showPagination = true;
                            }
                        }
                    }
                    else {
                        refTothis.hasResult = false;
                    }

                }).catch(err => {                 
                    if(err.response && err.response.status === 401) {
                        this.showNotAuthMessage= true ;

                    }
                });

            },
            MainKeyWordtranslation: function () {
                this.translationKeywords.productdescription = ResourceHelper.getString("productdescription");
                this.translationKeywords.biographicalNote = ResourceHelper.getString("biographicalNote");
                this.translationKeywords.keyWords = ResourceHelper.getString("keyWords");
                this.translationKeywords.addShoppingCart = ResourceHelper.getString("addShoppingCart");
                this.translationKeywords.addToWishList = ResourceHelper.getString("addToWishList");
                this.translationKeywords.noResult = ResourceHelper.getString("noResult");
                this.translationKeywords.termOfNotice = ResourceHelper.getString("termOfNotice");
                this.translationKeywords.audience = ResourceHelper.getString("audience");
                this.translationKeywords.termsAndConditions = ResourceHelper.getString("termsAndConditions");
                this.translationKeywords.author = ResourceHelper.getString("Author");
                this.translationKeywords.editor = ResourceHelper.getString("Editor");
                this.translationKeywords.orderTime = ResourceHelper.getString("OrderTime");
                this.translationKeywords.language = ResourceHelper.getString("Language");
                this.translationKeywords.publicationCountry = ResourceHelper.getString("PublicationCountry");
                this.translationKeywords.measures = ResourceHelper.getString("Measures");
                this.translationKeywords.bundle = ResourceHelper.getString("Bundle");
                this.translationKeywords.orderTimeDays = ResourceHelper.getString("OrderTimeDays");
                this.translationKeywords.keywords_NewbooksClassification = ResourceHelper.getString("keywords_NewbooksClassification");
                this.translationKeywords.keywords_Wgs = ResourceHelper.getString("keywords_Wgs");
                this.translationKeywords.keywords_Stil = ResourceHelper.getString("keywords_Stil");
                this.translationKeywords.keywords_Interessen = ResourceHelper.getString("keywords_Interessen");
                this.translationKeywords.keywords_Bildung = ResourceHelper.getString("keywords_Bildung");
                this.translationKeywords.keywords_Zeitepoche = ResourceHelper.getString("keywords_Zeitepoche");
                this.translationKeywords.keywords_Sprache = ResourceHelper.getString("keywords_Sprache");
                this.translationKeywords.keywords_Ort = ResourceHelper.getString("keywords_Ort");
                this.translationKeywords.keywords_Thema = ResourceHelper.getString("keywords_Thema");
                this.translationKeywords.keywords_Warengruppe = ResourceHelper.getString("keywords_Warengruppe");
                this.translationKeywords.keywords_Schlagworte = ResourceHelper.getString("keywords_Schlagworte");
                this.translationKeywords.keywords_Lesemotive = ResourceHelper.getString("keywords_Lesemotive");
                this.translationKeywords.personIdentifier = ResourceHelper.getString("personIdentifier");

                this.translationKeywords.furtherInfo_Audience = ResourceHelper.getString("furtherInfo_Audience");
                this.translationKeywords.Series = ResourceHelper.getString("Series");
            },
            getString: function (name, defaultValue = "") {
                if (!name) return "";
                return ResourceHelper.getString(name, defaultValue);
            },
            ShowAllKeyWords: function () {
                this.showMoreKeyWords = true;
            },
            ShowAllMotifs: function () {
                this.showMoreMotifs = true;
            },
            formatMeasurement: function (value) {
                return value.toString();
            },
            Displaymeasurement: function (measurement) {
                var FinalResult = "";
                var Width = "";
                var Height = "";
                var UnitWeight = "";

                if (measurement != null) {
                    for (var i = 0; i < measurement.length; i++) {
                        var measurementObj = measurement[i];
                        if (measurementObj.measureType == 'Height') {
                            Height = Math.floor(measurementObj.measurement).toString();
                        }
                        else if (measurementObj.measureType == 'Width') {
                            Width = Math.floor(measurementObj.measurement).toString();
                        }
                        else if (measurementObj.measureType == 'UnitWeight') {
                            UnitWeight = measurementObj.measurement.toString();
                        }
                    }
                    if (Height || Width) {
                        FinalResult = Height + " x " + Width + " mm";
                    }
                    if (UnitWeight) {
                        FinalResult = FinalResult + ", " + UnitWeight + " gr";
                    }
                    return FinalResult;
                } else {
                    return "";
                }

            },
            onPageChange: function (page) {
                this.currentPage = page;
                var ISBN = getUrlParameter('Id');
                this.GetItemDetials(ISBN);
                this.CheckItemInTheCart();
            },
            formatetxt: function (value) {
                if (value != null) {
                    return value.replace(/(?:\r\n|\r|\n)/g, '<br/>');
                }
            },
            OpenwishList: function (value) {
                this.$emit('OpenwishList', value);
            },
            AddToShoppingCart: function (value) {
            },
            GetCodeList(name) {
                if (name == 16) return "ISNI";
                if (name == 25) return null;
                return name;
            },

        },
        created: function () {
            this.ElasticData = [];
            this.addedToCart = false;
            var DetialPage = getUrlParameter('Id');
            if (DetialPage !== undefined) {
                this.GetItemDetials(DetialPage);
                this.CheckItemInTheCart();
                this.MainKeyWordtranslation();
            }
        },
        watch: {
            productReference: function (newVal) {
                this.GetItemDetials(newVal);
                this.CheckItemInTheCart();
                this.MainKeyWordtranslation();
            },
            addedToCart: function (newVal) {
                this.addedToCart = newVal;
                return this.addedToCart;
            },
            ElasticData: function (newVal) {
                if (newVal != null && newVal.length > 0) {
                    var Authorindex = 0;
                    var Editindex = 0;
                    var contributors = this.ElasticData[0]._source.contributors;
                    this.searchRequestTerm = obj.query;
                    this.searchFormText = this.getString('searchFormNoResults').replace('{0}', this.searchRequestTerm);
                    if (contributors) {
                        this.AuthorsList = "";
                        this.EditorsList = "";
                        for (var contributor in contributors) {
                            if (contributors[contributor].contributorRole === "ByAuthor") {
                                if (Authorindex != 0) {
                                    this.AuthorsList += ", ";
                                }
                                this.AuthorsList += contributors[contributor].personName;
                                Authorindex++;
                            }
                            if (contributors[contributor].contributorRole === "EditedBy") {
                                if (Editindex != 0) {
                                    this.EditorsList += ", ";
                                }
                                this.EditorsList += contributors[contributor].personName;
                                Editindex++;
                            }
                        }

                    }
                }
            }
        },

        components: {
            pagination,
            ElasticSearchItem,
            wishList,
            searchRequest
        },
        computed: {
            BundlePriceTxt: function () {
                var BundlePrice = [];
                if (this.ElasticData[0]._source.price.bundle) {
                    var bundleObj = this.ElasticData[0]._source.price.bundleItems;
                    for (var item in bundleObj) {
                        var bundleItem = bundleObj[item];
                        var ItemSum = bundleItem.taxAmount + bundleItem.taxableAmount;
                        var BundlePricetxt = "";
                        if (Number(item) === 1) {
                            BundlePricetxt = " und ";
                        }

                        BundlePricetxt += bundleItem.productForm + " (Anteil  " + String(ItemSum).replace(".", ",") + " EUR)";
                        BundlePrice.push(BundlePricetxt);
                    }
                }
                return BundlePrice;
            }
        }
    }
</script>
<style>
    .expander {
        cursor: pointer;
        text-decoration: underline !important;
    }

        .expander:hover {
            color: #cb060b !important;
        }

    .tab-header {
        background-color: #eee !important;
        border: 1px solid rgba(0, 0, 0, 0.125);
        color: #414751 !important;
    }

        .tab-header:hover {
            background-color: #eee !important;
            border: 1px solid rgba(0, 0, 0, 0.125);
            color: #cb060b !important;
        }

        .tab-header:focus {
            background: #5a616b !important;
            border: 1px solid rgba(0, 0, 0, 0.125);
            color: #fff !important;
        }

    .card-area-body {
        border: hidden !important;
        background-color: #fff !important;
        border-bottom: hidden !important;
        border-top: hidden !important;
        padding: 0px;
    }

    .p-1 {
        border: hidden !important;
        background-color: #fff !important;
    }

    .relatedProduct {
        font-size: 12px;
        font-weight: bold;
        margin-left: 20px;
        cursor: pointer;
        text-decoration: underline !important;
    }

    /*        .relatedProduct:hover {
            color: #cb060b !important;
            text-decoration: underline !important;
        }*/

    .PdfLinks {
        cursor: pointer;
        text-decoration: underline !important;
    }

        .PdfLinks:hover {
            text-decoration: underline !important;
        }

    .biographicalTableLable {
        text-align: left;
        font-weight: bold;
        width: 12%;
        padding-bottom: 15px;
        vertical-align: top;
    }

        .biographicalTableLable span:after {
            content: ":";
        }

    .biographicalTableValue {
        text-align: left;
        vertical-align: top;
        padding-bottom: 15px;
    }

    .keywordTableLable {
        text-align: left;
        font-weight: bold;
        width: 12%;
        padding-bottom: 15px;
        vertical-align: top;
    }

    .keywordTableLable-tr {
        padding-bottom: 1px !important;
        padding-left: 30px;
    }

    .keywordTableLable-tr-key {
        font-weight: bold;
    }

    .keywordTableValue {
        text-align: left;
        vertical-align: top;
        padding-bottom: 15px;
    }

    .custom-split:not(:last-of-type)::after {
        content: ', ';
    }

    .biographicalTableValue p {
        margin-bottom: 0px !important;
    }

    .card-details-table table {
        width: 100% !important;
    }
    .contributor-section {
        width:100%;
        display: inline-flex;
        flex-direction: row;
        align-items: flex-start;
    }
    .person-identifier-link{
        text-decoration:underline;
    }
    .person-identifier-link:hover{
        text-decoration:underline;
    }
</style>